import { render, staticRenderFns } from "./detailFeedback.vue?vue&type=template&id=59dd59f3&"
import script from "./detailFeedback.vue?vue&type=script&lang=js&"
export * from "./detailFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports